import * as React from 'react';
import { cn } from '@/lib/utils';

export type WorkbookDividerStyle = 'torn-paper' | 'perforation';
export type WorkbookDividerTone = 'ink' | 'teal' | 'coral';

export interface WorkbookDividerProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'style'> {
  style?: WorkbookDividerStyle;
  tone?: WorkbookDividerTone;
  alt?: string;
}

const SRC: Record<WorkbookDividerStyle, string> = {
  'torn-paper': '/character-system/scribble/divider-torn-paper-v1.png',
  perforation: '/character-system/scribble/divider-perforation-v1.png',
};

const toneClass: Record<WorkbookDividerTone, string> = {
  ink: '',
  teal: 'opacity-85 saturate-[1.15] sepia-[0.18] hue-rotate-[125deg]',
  coral: 'opacity-85 saturate-[1.2] sepia-[0.25] hue-rotate-[-35deg]',
};

export const WorkbookDivider = React.forwardRef<HTMLImageElement, WorkbookDividerProps>(
  ({ style = 'torn-paper', tone = 'ink', alt = '', className, ...rest }, ref) => (
    <img
      ref={ref}
      src={SRC[style]}
      alt={alt}
      className={cn('block h-auto w-full select-none', toneClass[tone], className)}
      draggable={false}
      {...rest}
    />
  ),
);
WorkbookDivider.displayName = 'WorkbookDivider';
